export const notificationTypes = {
  INFO: 'info',
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
} as const;

export type TNotificationType =
  typeof notificationTypes[keyof typeof notificationTypes];
